import { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getCandidateByProject } from "../http/api";
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import Loading from "../loading/loading";
import "../common/style.css";
import DataTable from "react-data-table-component";
import { uploadCandidatesCSV } from "../http/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React from "react";

export default function ManageCandidates() {
  const { projectId } = useParams();
  const navigate = useNavigate();

  const [isSidebarOpen, setIsSidebarOpen] = useState(
    localStorage.getItem("sb|sidebar-toggle") === "true"
  );
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    localStorage.setItem("sb|sidebar-toggle", !isSidebarOpen);
  };

  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [search, setSearch] = useState("");

  const showErrorToast = (message) => {
    toast.error(
      ({ closeToast }) => (
        <div>
          <p style={{ margin: 0, fontWeight: "500" }}>{message}</p>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "10px",
              gap: "8px",
            }}
          >
            <button
              className="btn btn-sm btn-secondary"
              onClick={() => {
                console.log("User clicked Cancel");
                closeToast();
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                console.log("User clicked OK");
                closeToast();
              }}
            >
              OK
            </button>
          </div>
        </div>
      ),
      {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        position: "top-right",
      }
    );
  };

  // const fetchCandidates = useCallback(() => {
  //     setLoading(true);
  //     getCandidateByProject(projectId, page, perPage, search)
  //         .then((response) => {
  //             if (response.status === 200) {

  //                 const data = response.data;
  //                 setCandidates(data.content || []);
  //                 //console.log(response.data);
  //                 setTotalRows(data.totalElements || data.total || 0);
  //                 console.log(JSON.stringify(response.data, null, 2));

  //                 setCandidates(response.data.content || []);
  //             }
  //         })
  //         .catch((err) => {
  //             console.error("Error fetching candidates:", err);
  //             alert("Failed to fetch candidates");
  //         })
  //         .finally(() => setLoading(false));
  // }, [projectId, page, perPage, search]);
  const fetchCandidates = useCallback(() => {
    setLoading(true);
    getCandidateByProject(projectId, page, perPage, search)
      .then((response) => {
        if (response.status === 200) {
          const data = response.data;
          setCandidates(data.content || []);
          setTotalRows(data.totalElements || data.total || 0);
        }
      })
      .catch((err) => {
        console.error("Error fetching candidates:", err);
        alert("Failed to fetch candidates");
      })
      .finally(() => setLoading(false));
  }, [projectId, page, perPage, search]);

  useEffect(() => {
    fetchCandidates();
  }, [fetchCandidates]);

  const columns = [
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <button
            className="btn btn-sm btn-primary px-4 py-0 fs-14"
            onClick={() =>
              navigate(`/editCandidate/${projectId}/${row.aadharNumber}`)
            }
            title="Edit Candidate"
          >
            <i className="fas fa-edit"></i> Edit
          </button>

          {/* <button
                        className="btn btn-sm btn-danger"
                        onClick={() => {
                            if (window.confirm("Are you sure you want to delete this candidate?")) {
                                // TODO: Implement delete functionality
                                alert("Delete functionality not implemented yet");
                            }
                        }}
                        title="Delete Candidate"
                    >
                        <i className="fas fa-trash"></i> Delete
                    </button> */}
        </div>
      ),
      width: "150px",
    },
    {
      name: "Aadhar",
      selector: (row) => row.aadharNumber,
      sortable: true,
      width: "150px",
    },
    {
      name: "Name",
      selector: (row) => row.candidateName,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Mobile",
      selector: (row) => row.mobile,
      sortable: true,
      width: "120px",
    },
    {
      name: "Job Role",
      selector: (row) => row.projectTrans?.[0]?.jobrole || "-",
      sortable: true,
    },
  ];

  return (
    <div className="ManageCandidates">
      {loading && <Loading />}
      <div
        className={`sb-nav-fixed ${isSidebarOpen ? "sb-sidenav-toggled" : ""}`}
      >
        {/* Header */}
        <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />

        <div id="layoutSidenav">
          {/* Sidebar */}
          <SideNave isSidebarOpen={isSidebarOpen} />

          {/* Main Content */}
          <div id="layoutSidenav_content">
            <main>
              <div className="container-fluid px-4">
                <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
                  <h4>Manage Candidates (Project {projectId})</h4>
                  <button
                    className="btn btn-secondary"
                    onClick={() => navigate("/enroll")}
                  >
                    Back to Projects
                  </button>
                </div>

                <div className="card mb-4">
                  <div className="card-header">
                    <i className="fas fa-users me-1"></i>
                    Candidate List
                  </div>
                  <div className="card-body shadow-sm border-0">
                    <div className="d-flex justify-content-between mb-3">
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => navigate(`/addCandidate/${projectId}`)}
                        >
                          <i className="fas fa-user-plus"></i> Add Candidate
                        </button>
                        {/* <button
                                                    className="btn btn-sm btn-info"
                                                    onClick={() => {
                                                        // TODO: Implement upload functionality
                                                        alert("Upload functionality not implemented yet");
                                                    }}
                                                >
                                                    <i className="fas fa-upload"></i> Upload Candidates
                                                </button> */}
                        <button
                          className="btn btn-sm btn-info"
                          onClick={() =>
                            document.getElementById("csvUploadInput").click()
                          }
                        >
                          <i className="fas fa-upload"></i> Upload Candidates
                        </button>

                        <input
                          type="file"
                          id="csvUploadInput"
                          accept=".csv"
                          style={{ display: "none" }}
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (!file) return;

                            if (!file.name.endsWith(".csv")) {
                              alert("Please upload only CSV files.");
                              e.target.value = "";
                              return;
                            }

                            if (
                              window.confirm(
                                `Are you sure you want to upload ${file.name}?`
                              )
                            ) {
                              try {
                                setLoading(true);
                                const response = await uploadCandidatesCSV(
                                  file,
                                  projectId
                                );

                          
                                // Handle different success status codes
                                if (
                                  response.status === 201 ||
                                  response.status === 206
                                ) {
                                  const {
                                    totalCandidates,
                                    successfulCount,
                                    failedCount,
                                    validationErrors,
                                  } = response.data;

                                  // Show appropriate success message
                                  if (response.status === 201) {
                                    alert(
                                      `Candidates uploaded successfully!\nTotal: ${totalCandidates}\nSuccessful: ${successfulCount}`
                                    );
                                  } else {
                                    // 206 Partial Content
                                    if (
                                      validationErrors &&
                                      validationErrors.length > 0
                                    ) {
                                      // Show validation errors in alert
                                      const errorList =
                                        validationErrors.join("\n• ");
                                      alert(
                                        `Upload completed with some issues:\n\nSuccessful: ${successfulCount}\nFailed: ${failedCount}\n\nErrors:\n• ${errorList}`
                                      );
                                    } else {
                                      alert(
                                        `Upload partially successful:\nSuccessful: ${successfulCount}\nFailed: ${failedCount}`
                                      );
                                    }
                                  }

                                  fetchCandidates(); // refresh table
                                } else {
                                  alert(
                                    "Upload failed. Please check your CSV file."
                                  );
                                }
                              } catch (error) {
                                console.error("=== UPLOAD ERROR ===");
                                console.log("Error response:", error.response);

                                let errorMessage =
                                  "Something went wrong while uploading the CSV file.";

                                if (error.response?.data) {
                                  const responseData = error.response.data;
                                  console.log("Error data:", responseData);

                                  // Extract validation errors from the response
                                  if (
                                    responseData.validationErrors &&
                                    responseData.validationErrors.length > 0
                                  ) {
                                    // Join all validation errors into a single message
                                    errorMessage =
                                      responseData.validationErrors.join("\n");
                                  } else if (responseData.message) {
                                    errorMessage = responseData.message;
                                  } else if (typeof responseData === "string") {
                                    errorMessage = responseData;
                                  }

                                  // Log detailed error info
                                  console.error(
                                    JSON.stringify(
                                      {
                                        status: "error",
                                        message: errorMessage,
                                        validationErrors:
                                          responseData.validationErrors,
                                        statusCode: error.response.status,
                                        timestamp: new Date().toISOString(),
                                      },
                                      null,
                                      2
                                    )
                                  );
                                }

                                // Show toast with the proper validation error message
                                showErrorToast(errorMessage);
                              } finally {
                                setLoading(false);
                                e.target.value = "";
                              }
                            }
                          }}
                        />

                        {/* <button
                                                    className="btn btn-sm btn-info"
                                                    onClick={() => {
                                                        // TODO: Implement upload functionality
                                                        alert("Working on Button");
                                                    }}
                                                >
                                                    <i className="fas fa-upload"></i> Sample Data
                                                </button> */}
                        <button
                          className="btn btn-sm btn-info"
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = "/Sample.csv"; // file path in public folder
                            link.download = "Sample.csv";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }}
                        >
                          <i className="fas fa-download"></i> Sample CSV
                        </button>
                      </div>
                      <div
                        className="input-group input-group-sm"
                        style={{ width: "220px" }}
                      >
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search..."
                          value={search}
                          onChange={(e) => {
                            setSearch(e.target.value);
                            setPage(0);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") fetchCandidates();
                          }}
                        />
                        <button
                          className="btn btn-outline-primary"
                          onClick={fetchCandidates}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </div>

                      {/* <button
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={fetchCandidates}
                                                title="Refresh candidates list"
                                            >
                                                <i className="fas fa-sync-alt"></i> Refresh
                                            </button> */}
                    </div>

                    {candidates.length === 0 ? (
                      <div className="text-center py-4">
                        <i className="fas fa-users fa-3x text-muted mb-3"></i>
                        <h5 className="text-muted">No candidates found</h5>
                        <p className="text-muted">
                          Add candidates to this project to get started.
                        </p>
                        <button
                          className="btn btn-success"
                          onClick={() => navigate(`/addCandidate/${projectId}`)}
                        >
                          <i className="fas fa-user-plus"></i> Add First
                          Candidate
                        </button>
                      </div>
                    ) : (
                      <DataTable
                        className="data-table"
                        columns={columns}
                        data={candidates}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        onChangePage={(pageNumber) => setPage(pageNumber - 1)} // react-data-table uses 1-based indexing
                        onChangeRowsPerPage={(newPerPage) => {
                          setPerPage(newPerPage);
                          setPage(0);
                        }}
                        highlightOnHover
                        responsive
                        striped
                      />
                    )}

                    <ToastContainer />
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
